import Box from "@mui/material/Box";
import { useEffect } from "react";

import { useAppDispatch } from "~/app/store";

import { useNavbar } from "~/hooks/useNavbar";
import { useLazyGetWorkstationsQuery } from "~/redux/warehouse/workstation.hooks";

import EventExplorer from "./EventExplorer";
import { clearAndonWorkstationsAndGrids, clearEventData } from "./andon.slice";

function Events() {
  const [triggerFetchWorkstations] = useLazyGetWorkstationsQuery();
  const dispatch = useAppDispatch();

  const { setMenuItems } = useNavbar();

  useEffect(() => {
    setMenuItems([
      {
        textContent: "Clear Andon Statuses and Fetch Workstations",
        actionCb: () => {
          dispatch(clearAndonWorkstationsAndGrids());
          void triggerFetchWorkstations();
        }
      },
      {
        textContent: "Clear Events",
        actionCb: () => {
          dispatch(clearEventData());
        }
      }
    ]);
  }, [setMenuItems, dispatch, triggerFetchWorkstations]);

  return (
    <Box
      id="tab-content"
      sx={{
        width: "100%",
        overflowX: "hidden"
      }}
    >
      <EventExplorer />
    </Box>
  );
}

export default Events;
